import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'
import ListStatisticsSpecialist from './ListStatisticsSpecialist'

const SpecialistStatisticsRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListStatisticsSpecialist /></PrivateRoute7>} />
    </Routes>
  )
}

export default SpecialistStatisticsRoutes